export default `
(function () {
    function load() {
        if (window.cookiehub) {
            window.cookiehub.load({});
            return true;
        }
        return false;
    }
    if (!load()) {
        var interval = setInterval(function () {
            if (load()) clearInterval(interval);
        }, 50);
    }
})();
`;
